<!-- <div class="guest-data">
<div for="" class="page-title guest-data__page-title">{{'reservationDetails'| translate}}</div>
<div class="guest-data__reservation-data content-summary">
  <div style="width: 100%;">
    <span class="guest-data__guest-info-text"
      @if (partyDetails.specialMeal && partyDetails.specialMeal.Name) {>{{partyDetails.specialMeal.Name}}
      <span @if (paymentData && paymentData.SpecialMealAmountinfo && paymentData.SpecialMealAmountinfo >0) {>-
      {{paymentData.OperationCurrency}}{{paymentData.SpecialMealAmountinfo}}</span></span>
      <span class="guest-data__guest-info-text">{{partyDetails.partySize}} Party</span>
      <span class="guest-data__guest-info-text">{{partyDetails.reservationTime | date:'dd/MM/yyyy'}}</span>
      <span class="guest-data__guest-info-text">{{partyDetails.reservationTime| date:'h:mm a'}}</span>
      <span class="guest-data__guest-info-text"
        @if (partyDetails.seatingType && partyDetails.seatingType.name) {>{{partyDetails.seatingType.name}}
        <span @if (paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0) {>-
        {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo}}</span>
      </span>
      <span class="guest-data__guest-info-text"
        @if (paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0) {>-
      {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo}}</span>
    </div>
    <div style="padding: 0 12px;">
      <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
    </div>
  </div>

  <div class="guest-data__guest-data">
    <ng-scrollbar>
      <div class="guest-data__guest-info" @for (guest of guestData; track guest) {
        <div for="" class="section-header guest-data__guest-title">{{guest | translate}}</div>
        <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
        </dynamic-form>
      </div>
      <div style="display: flex;flex-direction: column;" @if (noShowfee >0 && !rs.additionalGuestPage) {
      <span class="default-sub-header" style="
        padding-bottom: 8px;margin-top: 16px;
    ">{{'noShowPolicy' | translate}}</span>
      <div class="default-form-field mb-0" style="    background: #f7f7f7;
        padding: 15px;
        border-radius: 4px;width: 560px;">
          <span>No Show Cancellation Fee : {{paymentData.OperationCurrency}}{{noShowfee}}</span>
        <p class="" style="    padding-top: 8px;
        margin-bottom: 0;">
            {{noShowfeeMessage}}
          </p>
        </div>
      </div>
      <div style="display: flex;flex-direction: column;" @if (activityPayment>0 && !rs.additionalGuestPage) {
      <span class="default-sub-header" style="
        padding-bottom: 8px;margin-top: 16px;
    ">Pre Payment Policy</span>
      <div class="default-form-field mb-0" style="    background: #f7f7f7;
        padding: 15px;
        border-radius: 4px;width: 560px;">
          <span>Payment : {{paymentData.OperationCurrency}}{{activityPayment}}</span>
        <p class="" style="    padding-top: 8px;
        margin-bottom: 0;">
            {{paymentMessage}}
          </p>
        </div>
      </div>
    </ng-scrollbar>
  </div>
  <app-button
  [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
  <div class="guest-data__actions">
    <app-button [buttontype]="previousButton" (valueChange)="getSeatSelection()"></app-button>
    <app-button [buttontype]="confirmButton" (valueChange)="reservationConfirm()"></app-button>
  </div>
  <div @if (showIframe) {><iframe width="100%" height="700px" frameBorder="0" [src]="urlSafe"></iframe></div>
</div> -->



<div class="guest-data">
  @if (TotalAmount || !gs.restaurantWidgetSettings$.value.IsCartEnabled) {
    <div class="guest-data__header-container">
      <div class="guest-data__amount-container">
        @if (TotalAmount) {
          <div class="guest-data__amount-payable-header">{{'TotalPayableAmount' | translate}}&nbsp;:
          </div>
        }
        @if (TotalAmount) {
          <div class="guest-data__amount-payable">
          &nbsp;{{gs.restaurantWidgetSettings$.value.OperationCurrency}}{{TotalAmount | currencyDecimalFormatter }}</div>
        }
      </div>
      @if (!gs.restaurantWidgetSettings$.value.IsCartEnabled || gs.operation != operationType.create) {
        <div class="guest-data__time-container"
          >
          <div class="focused-sub-header  guest-data__time-mins"
            [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#f5e205'} : {'color':'#05f5f5'}"><span
          class="guest-data__timer-number">{{gs.minutes}}</span>
          <span class="error-message">{{'mins' | translate}}</span> <span
        class="guest-data__timer-number">{{gs.seconds}}</span> <span class="error-message">{{'secs' |
      translate}}</span>
    </div>
    <div class="guest-data__time-left-text">{{'leftForBooking' | translate}}</div>
  </div>
}
</div>
}

@if (gs.operation==operationType.create && !gs.additionalGuestPage) {
  <div for="" class="page-title guest-data__page-title"
    >
  {{'reservationDetails'| translate}}</div>
}
@if (gs.operation==operationType.edit) {
  <div for="" class="page-title guest-data__page-title">
  {{'ModifiedReservationDetails' | translate}}</div>
}
<!-- <div class="guest-data__remaining-time-indicator" @if (gs.showTimer) {

</div> -->
<!-- <div class="guest-data__reservation-data content-summary" [ngStyle]="{'background-color':gs.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor}">
<div style="width: 100%;">
  <span class="guest-data__guest-info-text"
    @if (partyDetails.specialMeal && partyDetails.specialMeal.Name) {>{{partyDetails.specialMeal.Name}}
    <span @if (specialMealAmountInfo >0) {>-
    {{paymentData.OperationCurrency}}{{specialMealAmountInfo}}</span></span>
    <span class="guest-data__guest-info-text">{{partyDetails.partySize}} Party</span>
    <span class="guest-data__guest-info-text">{{partyDetails.reservationTime | date:'dd/MM/yyyy'}}</span>
    <span class="guest-data__guest-info-text">{{partyDetails.reservationTime| date:'h:mm a'}}</span>
    <span class="guest-data__guest-info-text"
      @if (partyDetails.seatingType && partyDetails.seatingType.name) {>{{partyDetails.seatingType.name}}
      <span @if (ratePlanAmountInfo >0) {>-
      {{paymentData.OperationCurrency}}{{ratePlanAmountInfo}}</span>
    </span>
    <span class="guest-data__guest-info-text"
      @if (!(ratePlanAmountInfo >0) && !(specialMealAmountInfo>0) && noShowfee >0 ) {>{{ 'amount' | translate}}
    {{paymentData.OperationCurrency}}{{noShowfee}}</span>
  </div>
  <div style="padding: 0 12px;">
    <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
  </div>
</div> -->
<div class="guest-data__guest-section">
  <!-- <ng-scrollbar> -->
  <!--Needed -->

  <!-- have to check -->
  <div class="guest-data__guest-data">
    @if (this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage) {
      <div class="guest-data__admin-msgs"
        >
        <i class="icon-Info guest-data__info-icon"></i>
        {{this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage}}
      </div>
    }
    @for (guest of guestData; track trackByGuest(i, guest); let i = $index) {
      <div class="guest-data__guest-info"
        [ngStyle]="{'background-color':gs.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
        <div for="" class="section-header guest-data__guest-title">{{guest.name | translate}}
          @if (gs.operation == operationType.edit && i!=0) {
            <i class="icon-DeleteWidget guest-data__delete-icon"
            (click)="openDeleteConfirmationPopUp(i)"></i>
          }
        </div>
        @if (gs.additionalGuestPage || i != 0) {
          <div class="guest-data__member-info" [hidden]="!guest.isNew">
            <dynamic-form [config]="membershipConfig" #memberForm="dynamicForm">
            </dynamic-form>
          </div>
        }
        @if (gs.operation != operationType.edit || (gs.operation == operationType.edit && i == 0)) {
          <div>
            <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
            </dynamic-form>
          </div>
        }
        @if (gs.operation == operationType.edit && i != 0) {
          <div>
            <dynamic-form [config]="guestInfoConfigSecondary" #form="dynamicForm">
            </dynamic-form>
          </div>
        }
        @if (cancellationPolicy) {
          <div class="guest-data__cancellation-policy-title">{{'cancellationPolicy'| translate}}:</div>
          <div class="guest-data__cancellation-policy">
            {{cancellationPolicy}}
          </div>
        }
      </div>
    }
    @if (urlSafe && !gs.editFromCart && (!gs.restaurantWidgetSettings$.value.IsCartEnabled || gs.operation != operationType.create || waiverForm)) {
      <div class="guest-data__iframe-view"
        >
        <iframe width="560px" height="650px" frameBorder="0" [src]="urlSafe"></iframe>
      </div>
    }
    @if (activityPayment>0 && !rs.additionalGuestPage && gs.operation==operationType.create) {
      <div style="display: flex;flex-direction: column;"
        >
        <span class="default-sub-header" style="
          padding-bottom: 8px;margin-top: 16px;
      ">Pre Payment Policy</span>
        <div class="default-form-field mb-0" style="    background: #f7f7f7;
          padding: 15px;
          border-radius: 4px;width: 560px;">
          <span>Payment : {{paymentData.OperationCurrency}}{{activityPayment | currencyDecimalFormatter}}</span>
          <p class="" style="    padding-top: 8px;
          margin-bottom: 0;">
            {{paymentMessage}}
          </p>
        </div>
      </div>
    }
  </div>


  <div class="guest-data__actions">
    <div class="d-inline-block">
      @if (((gs.additionalGuestPage  && (gs.additionalGuestRequired) > guestData.length)|| (gs.operation == operationType.edit && !gs.editFromCart && (gs.additionalGuestLength > guestData.length))) && gs.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails) {
        <app-button
        [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
      }
    </div>
    <div class="d-inline-block">
      @if (gs.additionalGuestPage) {
        <app-button [buttontype]="backButton" (valueChange)="backtosummary()">
        </app-button>
      }
    </div>
    <div class="d-inline-block">
      @if (!gs.additionalGuestPage) {
        <app-button [buttontype]="previousButton" (valueChange)="getSeatSelection()">
        </app-button>
      }
    </div>
    <div class="d-inline-block">
      @if ((!gs.additionalGuestPage && (!gs.restaurantWidgetSettings$.value.IsCartEnabled)) || ( !gs.additionalGuestPage  && gs.operation == operationType.edit && !gs.editFromCart )) {
        <app-button
          [buttontype]="confirmButton" (valueChange)="reservationConfirm()">
        </app-button>
      }
    </div>
    <div class="d-inline-block">
      @if (!gs.additionalGuestPage && (gs.restaurantWidgetSettings$.value.IsCartEnabled && gs.operation == operationType.create)) {
        <app-button
          [buttontype]="addToButton" (valueChange)="addToCartData()">
        </app-button>
      }
    </div>
    <div class="d-inline-block">
      @if (!gs.additionalGuestPage && gs.editFromCart) {
        <app-button [buttontype]="bookBtn"
          (valueChange)="UpdateCart()">
        </app-button>
      }
    </div>
    <div class="d-inline-block">
      @if (gs.additionalGuestPage) {
        <app-button [buttontype]="SaveGuestbtn"
          (valueChange)="createSecondaryContacts()">
        </app-button>
      }
    </div>
  </div>
<!-- </ng-scrollbar> -->
</div>
</div>